import './App.css'
import { BrowserRouter as Router } from "react-router-dom";
import AnimatedRoutes from './components/AnimatedRoutes';
import { useEffect } from 'react';
// import crypto from "crypto";

function App() {

  useEffect(() => {
    const key = 'userUuid'

    let userUuid = localStorage.getItem(key)

    if(!userUuid) {
      userUuid = crypto.randomUUID()
      localStorage.setItem('userUuid', userUuid)
    }
  
  }, []);


  return (
    <Router>
      <AnimatedRoutes />
    </Router>
  )
}

export default App
